import { useIonToast } from '@ionic/react'
import { ConfirmPatientReportParams } from 'domain/usecases/confirm-patient-report'
import { Patient } from 'domain/usecases/get-patient'
import { PatientsService } from 'infra/services/patients-service'
import { ReportsService } from 'infra/services/reports-service'
import { ButtonRound, Viewport } from 'presentation/components'
import { ModalNewReport } from 'presentation/pages/modal-new-report/modal-new-report'
import React, { useEffect, useRef, useState } from 'react'
import './patient-heading.scss'
import { UserInfo, UserRole } from 'infra/services/usecases/get-user-info'
import { ClinicsService } from 'infra/services/clinics-service'
import { useRecoilState } from 'recoil'
import { reportPatientAtom } from 'presentation/pages/modal-new-report/modal-new-report-atom'

interface PatientHeadingProps {
  reportsService: ReportsService
  patientsService: PatientsService
  patientItem: Patient
  user: UserInfo
  clinicsService: ClinicsService
  refreshPatient: () => void
}

const PatientHeading: React.FC<PatientHeadingProps> = (props) => {
  const modalNewReport = useRef<HTMLIonModalElement>(null)
  const [confirmedPatient, setConfirmedPatient] = useRecoilState(reportPatientAtom)
  const [isModalReportOpen, setModalReportOpen] = useState<boolean>(false)
  const [presentToast] = useIonToast()

  const handleCreateReport = (reportId: string, oncologistId: string) => {
    props.reportsService
      .confirmPatientReport({ 
        ...props.patientItem, 
        reportId, 
        oncologist: props.user.name, 
        oncologistId: oncologistId,
        nameError: '',
        mrnError: '',
      })
      .then(() => {
        setModalReportOpen(false)
        props.refreshPatient()
      })
      .catch(() => showToastError('There was an error trying to confirm patient, try again later.'))
  }

  const showToastError = (message: string) => {
    presentToast({
      message: message,
      duration: 5000,
      color: 'danger',
    })
  }

  useEffect(() => {
    setConfirmedPatient({
      ...confirmedPatient,
      reportId: '',
    })
  }, [props.patientItem])

  return (
    <section id="patient-heading">
      <Viewport>
        <div className="ph-background">
          <div className="ph-info">
            <div className="ph-chip">MRN: {props.patientItem.MRN}</div>
            <h1>{props.patientItem.name}</h1>
            <span>
              Birth: {props.patientItem.birthdate} - {props.patientItem.age}yo / Sex: {props.patientItem.sex}
            </span>
          </div>
          <div>
            {(props.user.role === UserRole.Oncologist || props.user.role === UserRole.MedicalAssistant) && (
              <ButtonRound size="small" color={'light'} onClick={() => setModalReportOpen(true)}>
                + New Report
              </ButtonRound>
            )}
          </div>
        </div>
      </Viewport>

      <ModalNewReport
        trigger="trigger-modal-report"
        modal={modalNewReport}
        isOpen={isModalReportOpen}
        reportsService={props.reportsService}
        patientsService={props.patientsService}
        clinicsService={props.clinicsService}
        userInfo={props.user}
        notNeededToConfirm={true}
        onCreateReport={(reportId, oncologistId) => handleCreateReport(reportId, oncologistId)}
        onDidDismiss={() => setModalReportOpen(false)}
      />
    </section>
  )
}

export default PatientHeading
